import React, { createRef } from 'react'
import { connect } from 'react-redux'
import { Layout, NavDrawer, Panel } from 'react-toolbox/lib/layout'
import { compose } from 'recompose'

import withRoles from 'containers/Role/Project/index'
import injectSagas from 'helpers/injectSagas'
import Actionbar from './Actionbar'
import asyncDialogHoc from 'containers/Async/AsyncDialog'
import Sidebar from 'containers/Project/UpdateSidebar/index'
import ProjectForm from 'containers/Form/Project/index'
import { loadProjectForm } from 'containers/Project/actions'
import { workflowIdSelector } from 'containers/Project/selectors'
import {
  LOAD_PROJECT_FORM,
  LOAD_PROJECT_FORM_DATA,
} from 'containers/Project/constants'
import {
  dispatchValidateFormStart
} from 'containers/Form/Validation/actions'
import { clearRedirect as clearRedirectAction } from './actions'
import { redirectSelector } from './selectors'
import ProjectUpdateSagas from './sagas'

import {
  formattedCategoriesSelector,
} from 'containers/Project/OverviewSidebar/selectors'
import {
  brandSelector,
  productGpuSkuSelector,
  productSkuSelector,
  partnerSiteNameSelector,
  projectIdSelector,
  segmentSelector,
} from 'containers/Project/View/selectors'
import {
  scrollTop
} from 'containers/Project/View/actions'
import {
  riskSelector,
} from 'containers/Form/RiskValidation/selectors'

import styles from './styles.scss'


const AsyncDialog = asyncDialogHoc([
  LOAD_PROJECT_FORM,
  LOAD_PROJECT_FORM_DATA,
])

const mapStateToProps = (state) => {
  return {
    redirect: redirectSelector(state),
    projectId: projectIdSelector(state),
    gpuSku: productGpuSkuSelector(state),
    productBrand: brandSelector(state),
    partnerSite: partnerSiteNameSelector(state),
    productSku: productSkuSelector(state),
    segment: segmentSelector(state),
    categories: formattedCategoriesSelector(state),
    isRisk: riskSelector(state),
    restricted: state.uiState.project.restricted,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadProjectForm: (id, isUpdate) => dispatch(loadProjectForm(id, isUpdate)),
    onSave: () => dispatch(dispatchValidateFormStart()),
    clearRedirect: () => dispatch(clearRedirectAction()),
    scrollTopAction: (isTop) => dispatch(scrollTop(isTop))
  }
}

class ProjectUpdate extends React.Component {

  constructor(props) {
    super(props);
    this.scrollDivRef = createRef();
  }
  
  componentWillUnmount() {
    this.props.clearRedirect()
  }

  componentDidMount() {
    this.props.loadProjectForm(this.props.match.params.id, true)
  }

  render() {
    const {
      match,
      onSave,
      redirect,
      projectId,
      productSku,
      productBrand,
      gpuSku,
      segment,
      partnerSite,
      isRisk,
      restricted
    } = this.props

    return (
      <Layout theme={styles}>
        <NavDrawer
          pinned
          theme={styles}>
          <Sidebar/>
        </NavDrawer>
        <Panel theme={styles}>
          <ProjectForm 
            isNewProject={false}
            update
            projectId={projectId}
            productSku={productSku}
            productBrand={productBrand}
            gpuSku={gpuSku}
            segment={segment}
            partnerSite={partnerSite}
            risk={isRisk}
            />
          <AsyncDialog title='Loading Form in Progress...'/>
        </Panel>
        <Actionbar
          id={match.params.id}
          onClick={onSave}
          redirect={redirect}
        />
      </Layout>
    )
  }
}


const withConnect = connect(mapStateToProps, mapDispatchToProps)
const enhance = compose(
  //withRoles,
  withConnect,
  injectSagas({ ProjectUpdateSagas })
)
export default enhance(ProjectUpdate)
